import { Fullscreen } from "../../../library-js/dom-actions/Fullscreen";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick, OnMouseDown, OnMouseEnter, OnMouseMove } from "../../../library-js/dom-tools/EventListeners";
import { Duration } from "../../../library-js/date/Duration";
import { MathX } from "../../../library-js/math/MathX";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { DOMOrientation, DOMOrientationType } from "../../../library-js/dom/DOMOrientation";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { Link, LinkType } from "../../../library-js/dom-tools/LinkResolver";
import { sleep } from "../../../library-js/animation/sleep";

export class MiniVideoData
{
  hideTime = 0;
  scheduledPlaying = false;
}

export class MiniVideo
{
  static readonly type = new ElementType( "mini-video" );
  static readonly audioButton = new ElementType( "audio-button" );
  static readonly playButton  = new ElementType( "play-button" );
  static readonly fullscreenButton  = new ElementType( "fullscreen-button" );
  static readonly timeDisplay  = new ElementType( "time-display" );
  static readonly playBar  = new ElementType( "play-bar" );
  static readonly playIndicator  = new ElementType( "play-indicator" );
  static readonly miniControls  = new ElementType( "mini-controls" );

  static readonly playMode = new ElementAttribute( "play-mode" );
  static readonly source = new ElementAttribute( "source" );

  static readonly playing = new ClassFlag( "playing" );
  static readonly muted   = new ClassFlag( "muted" );
 
  static maps = new Map<HTMLVideoElement,MiniVideoData>();

  static orientationListener:any = null;
  static elements:Element[];

  static pageHandler:PageHandler;

  static applyOnDocument( pageHandler:PageHandler )
  {
    this.pageHandler = pageHandler;

    if ( ! MiniVideo.orientationListener )
    {
      screen.orientation.addEventListener( "change", ()=>
      {
        MiniVideo.elements.forEach( e => MiniVideo.updateVideoPlay( e ) );        
      }
      );
    }

    MiniVideo.elements = [];
    MiniVideo.maps = new Map<HTMLVideoElement,MiniVideoData>();
    MiniVideo.type.forAllInDoc( e => MiniVideo.applyOnElement( e ) );
  }

  static updateVideoPlay( e:Element )
  {

  }

  static async setSource( e:Element )
  {
    let video = ElementType.video.query( e );
    let sourceElement = ElementType.source.create();
    let sourceValue = ElementAttribute.rootHref.from( e );
    ElementAttribute.src.to( sourceElement, sourceValue );
    video.appendChild( sourceElement );
  }

  static applyOnElement( e:Element )
  {    
    MiniVideo.elements.push( e );
    let video = ElementType.video.query( e );
    let data = new MiniVideoData();
    data.hideTime = 0;
    MiniVideo.maps.set( video, data );

    let playOrientation = MiniVideo.playMode.from( e );

    if ( playOrientation === "Any" || DOMOrientationType[ DOMOrientation.type  ] === playOrientation )
    {
      MiniVideo.setSource( e );
    } 

    console.log( e, "playOrientation", playOrientation, "type", DOMOrientation.type, DOMOrientationType[ DOMOrientation.type  ] )


    video.volume = 0;

    if ( ! video.paused || ElementAttribute.autoplay.in( video ) )
    {
      MiniVideo.playing.set( e );
    }

    if ( video.volume < 0.5 )
    {
      MiniVideo.muted.set( e );
    }
    
    let c = MiniVideo.miniControls.query( e );

    let onMouseImpulse = ()=>
    {
      let time = new Date().getTime() + 1000;
      data.hideTime = time;

      ClassFlag.visible.set( c );
      setTimeout(
        ()=>
        {
          let currenTime = new Date().getTime();
          let data = MiniVideo.maps.get( video );

          if ( data.hideTime > currenTime )
          {
            return;
          }

          ClassFlag.visible.removeFrom( c );
        },
        2000
      );
    }

    OnMouseMove.add( video, onMouseImpulse );

    video.addEventListener( "play",  ()=> MiniVideo.playing.set( e ) );
    video.addEventListener( "pause", ()=> MiniVideo.playing.removeFrom( e ) );

    video.addEventListener( "timeupdate",
     ()=>
     {
      
      let elapsed   = Duration.format( video.currentTime );
      let duration  = Duration.format( video.duration );

      let state   = video.currentTime / ( isNaN( video.duration ) ? 1 : video.duration );

      state = MathX.clamp01( state );

      let timeDisplay = MiniVideo.timeDisplay.query( e );
      timeDisplay.innerHTML = `${elapsed} | ${duration}`;

      let playBarBounds = MiniVideo.playBar.query( e ).getBoundingClientRect();
      let indicator = MiniVideo.playIndicator.query( e ) as HTMLElement;
      indicator.style.left = playBarBounds.width * state + "px";
     } 
     );
 
    OnClick.add( MiniVideo.fullscreenButton.query( e ) as HTMLElement, 
    ( )=>
    { 
      Fullscreen.toggle( e );
     
    });

    let playBar = MiniVideo.playBar.query( e ) as HTMLElement;
    OnMouseDown.add( playBar, 
    ( ev )=>
    { 
      let position = DOMHitTest.getNormalizedPointerPosition( ev, playBar ); 
      video.currentTime = position.x * video.duration;

      console.log( position.x, position.x * video.duration )
     
    });

    OnClick.add( MiniVideo.audioButton.query( e ) as HTMLElement, 
     ( )=>
     {
       if ( video.muted )
       {       
         video.muted = false;
         ElementAttribute.muted.removeFrom( video );
         MiniVideo.muted.removeFrom( e );
         video.volume = 1;
       }
       else
       {
         video.muted = true;
         ElementAttribute.muted.to( video );
         MiniVideo.muted.set( e );
         video.volume = 0;
       }

       console.log( video.volume );
     }
    );

    let  togglePlay = async ()=>
    {
      if ( video.paused )
      {
        while ( data.scheduledPlaying )
        {
          await sleep( 100 );

          if ( ! video.paused )
          {
            return;
          }
        }

        data.scheduledPlaying = true;

        try
        {
          await video.play();
        }
        catch ( x  )
        {
          console.log( "couldnt play", x );
        }

        data.scheduledPlaying = false;
        
      }
      else
      {
        video.pause();
      }
    };

    OnClick.add( video, togglePlay );
    OnClick.add( MiniVideo.playButton.query( e ) as HTMLElement, togglePlay );
  }


}